import { render } from "./NewChatForm.vue?vue&type=template&id=2cee5786&scoped=true"
import script from "./NewChatForm.vue?vue&type=script&lang=js"
export * from "./NewChatForm.vue?vue&type=script&lang=js"

import "./NewChatForm.vue?vue&type=style&index=0&id=2cee5786&scoped=true&lang=css"

import exportComponent from "C:\\Users\\marti\\Documents\\dev\\JavaScript\\live-chat\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cee5786"]])

export default __exports__